import React, { useEffect, useRef, useState } from "react";
import userImage from "../../assets/images/folder.png";
import fileImage from "../../assets/images/file.png";
import more from "../../assets/images/more3.png";
import moment from "moment";
import { getFileIcon } from "../../utils";
import { useDispatch } from "react-redux";
import { getFolders, copyRepository, moveRepository, getRepository } from "../../redux/slices/apiSlice";
import { useSelector } from "react-redux";
import UseToast from "../../hooks/useToast";



const CopyFolder = ({ onClose, copiedFolderId, isMove=false, mainParentId, rootParentObj }) => {
  const [currentParentId, setCurrentParentId] = useState(null);
  const token = sessionStorage.getItem("token");
  const dispatch = useDispatch();
  const [folders, setFolders] = useState([]);
  const { foldersList } = useSelector((state) => state.api);
  const { successToast, errorToast } = UseToast();



  useEffect(() => {
    if (!foldersList?.result || !foldersList?.result.length) {
      setFolders([]);
    }
    // else if(!currentParentId){
    //   const agencyArr = [...new Map(foldersList?.result.map(item => [item.agency, {...item, name: item.agency}])).values()];
    //   setFolders(agencyArr)
    // }
    else {
      setFolders(foldersList.result);
    }
  }, [foldersList]);

  // useEffect(() => {
  //   const folderlist = getFoldersAtCurrentLevel(folders, currentParentId);
  //   console.log("folderlist GGGGGGGGGGGG ", folderlist);
  //   setDisplayedFolders(folderlist);
  // }, [folders]);

  const fetchFolders = async (parentId) => {
    try {
      const headers = {
        Accept: "application/json",
        Authorization: token,
      };
      dispatch(getFolders({ payload: { id: parentId || "" }, headers })); // , user_id: user?._id
    } catch (error) {
      console.error("Error fetching folders:", error);
    }
  };

  useEffect(() => {
    fetchFolders(currentParentId || null);
  }, [currentParentId]);

  const handleFolderClick = (folder) => {
    const folderId = folder._id;
    setCurrentParentId(null);
    if (folder.parent_id) {
      setCurrentParentId(folderId);
    } else {
      let agency = folders?.map((item) => item.agency);
      if (agency.includes(folder.name)) {
        setFolders(folders);
      } else {
        setCurrentParentId(folderId);
      }
    }
  };
  const copyFolderHandler = async () => {

    try {
      console.log("currentParentId , copiedFolderId =====+++++++++++ ", currentParentId, copiedFolderId);
      if (!currentParentId) {
        errorToast("No folder or file can be copied to the root.");
      } else if (currentParentId == copiedFolderId) {
        errorToast("A folder cannot be copied into itself.");
      } else {
        const headers = {
          accept: "application/json",
          authorization: token,
        };
        let response; 
        if(isMove){
          let payload = {
            repository_id: [
              copiedFolderId
            ],
            moveToRepository: currentParentId
          }
          response = await dispatch(moveRepository({ payload, headers }));
          dispatch(getRepository({ payload:{id: mainParentId || "",  rootParentId: rootParentObj?.rootFolderId || "" }, headers })); // , user_id: user?._id
          onClose();
        }else{
          let payload = {
            repository_id: [
              copiedFolderId
            ],
            copyToRepository: currentParentId
          }
          response = await dispatch(copyRepository({ payload, headers }));
        }
        if (response?.payload?.status) {
          successToast(response?.payload?.message);
          onClose();
        } else if (response?.error?.message) {
          errorToast(response?.error?.message);
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  }

  const getFoldersAtCurrentLevel = (folders, parentId) => {
    if (!folders.length) return [];
    if (parentId === null) {
      return folders;
    }
    const findChildren = (foldersList, targetId) => {
      for (const folder of foldersList) {
        if (folder._id === targetId) {
          return folder.children || [];
        }
        if (folder.children) {
          const result = findChildren(folder.children, targetId);
          if (result.length) return result;
        }
      }
      return [];
    };
    return findChildren(folders, parentId);
  };


  const displayedFolders = getFoldersAtCurrentLevel(folders, currentParentId || null);


  return (
    <div className="formBox">

      <div className="folderList grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
        {displayedFolders
          .filter((folder) => folder.type === "folder")
          ?.map((folder) => (
            <li key={folder._id} className="relative list-none">
              <div className="repositoryBox bg-white shadow-md rounded-lg">
                <div className="top flex justify-between items-center">
                  <button
                    disabled={folder.type === "file"}
                    onClick={() => handleFolderClick(folder)}
                    className="w-[90%] p-4"
                  >
                    <div className="folderIcon">
                      {folder.type === "folder" ? (
                        <img src={userImage} alt="Folder" />
                      ) : (
                        <img
                          src={
                            folder.s3_file_name
                              ? getFileIcon(folder.s3_file_name)
                              : fileImage
                          }
                          alt="File"
                          className="h-7"
                        />
                      )}
                    </div>

                    <div className="folerDesc mt-2">
                      <a className="folderName cursor-pointer text-blue-600 font-semibold">
                        {folder.name}
                      </a>
                      <div className="bottom text-gray-500 text-sm">
                        {folder.createdAt
                          ? moment(folder.createdAt).format("DD MMM YYYY")
                          : ""}
                      </div>
                    </div>
                  </button>

                </div>
              </div>

            </li>
          ))}
      </div>
      <div class="form-group !mb-0">
        <button class="blueBtn mr-2" onClick={onClose}>
          Cancel
        </button>
        <button class="blueBtn" onClick={copyFolderHandler}>
          Select
        </button>
      </div>

    </div>
  );
};

export default CopyFolder;
